import React, { Component } from "react";
import axios from "../../axios";
import Alert from "react-s-alert";
import FormDropdown from "../../components/FormDropdown";
import { status_aktif } from "../../constants/general";
import qs from 'qs';

import Select from "react-select";
import { FOTO_CONTENT_HOST } from "../../constants/siteConfig";
import Dropzone from 'react-dropzone'
import { MEDIA_HOST } from '../../constants/siteConfig'

import Cropper from "react-crop";
import "react-crop/cropper.css";

import "babel-core/register";
import "babel-polyfill";

import { EditorState, convertToRaw, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {dateIndo} from "../../functions/functionGeneral";
import {NavLink} from "react-router-dom";

class Forms extends Component {
	constructor(props) {
		super(props);

		this.state = {
			cat_id: "",
			content_id: "",
			content_type:"",
			content_name: "",
			nama_file: [],
			nama_files:[],
			nama_file_exist:[],
			content_image: "",
			content_shortdesc: "",
			content_desc: "",
			content_status: "",
			isButtonLoading: false,
			isLoading: false,
			image: null,
			previewImg: null,
			defaultImg: "./noimage.gif",
			editorState: EditorState.createEmpty(),
			dataCat: [],
			isLoadingDataKelas: false,
			dataKelas           : [],
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChangeMultiSelect = this.handleChangeMultiSelect.bind(this);
	}

	handleChange(event) {
		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
	}

	handleChangeMultiSelect(stateName, text) {
		this.setState({[stateName]: text});

		if (stateName == 'participants') {
			let kelas = [];
			for (var i = 0; i < text.length; i++) {
				kelas.push(text[i].value);
			}

			const kelasNew = kelas.join(',');

			this.setState({
				kelasNew
			});
		}

	}

	onChange(evt) {
		this.setState({
			previewImg: null,
			defaultImg: null,
			image: evt.target.files[0],
			content_image: ""
		});
	}

	async crop() {
		let image = await this.refs.crop.cropImage();
		this.setState({
			previewImg: window.URL.createObjectURL(image),
			defaultImg: null,
			content_image: window.URL.createObjectURL(image)
		});
	}

	clear() {
		this.refs.file.value = null;
		this.setState({
			previewImg: null,
			defaultImg: "./noimage.gif",
			image: null,
			content_image: ""
		});
	}

	imageLoaded(img) {
		if (
			img.naturalWidth &&
			img.naturalWidth < 262 &&
			img.naturalHeight &&
			img.naturalHeight < 147
		) {
			this.crop();
		}
	}

	onDrop = nama_file => {
		let newState = [...this.state.nama_file];

		for (var i = 0; i < nama_file.length; i++) {
			newState.push({nama_file:nama_file[i]})
		}
		// console.log(newState)
		this.setState({
			nama_files : newState,
			nama_file : nama_file
		});
	};
	
	handleDeleteFile() {

        this.setState({
            nama_file: []
        })
    }

	onEditorStateChange(editorState) {
		this.setState({
			content_desc: draftToHtml(convertToRaw(editorState.getCurrentContent())),
			editorState: editorState
		});
	}

	loadDataKelas() {
		this.setState({isLoadingDataKelas: true});

		const params = qs.stringify({
			locale: "id",
			platform: "web"
		})
		axios({
			method: 'post',
			url: '/kelas'
		})

			.then(response => {
				const result = response.data;
				if (result.success) {
					const dataKelas = result.data.map(item => ({
						value: item.kelas_id,
						label: item.kelas_nama
					}));

					this.setState({
						dataKelas,
						isLoadingDataKelas: false
					});
				} else {
					if (Array.isArray(result.text)) {
						result.text.map(item => {
							Alert.error(item);

							return true;
						});
					} else {
						Alert.error(result.text);
					}

					this.setState({isLoadingDataKelas: false});
				}
			})
			.catch(error => {
				console.log(error);
				this.setState({isLoadingDataKelas: false});
				Alert.error("Gagal terhubung ke server!");
			});
	}

	handleSubmit() {
		let formData = new FormData();

		const config = {
			headers: { "content-type": "multipart/form-data" }
		};

		formData.append("cat_id", "");
		formData.append("content_id", this.state.content_id);
		formData.append("content_type", "pengumuman");
		formData.append("content_name", this.state.content_name);
		formData.append("content_image", this.state.image);
		formData.append("content_shortdesc", this.state.content_shortdesc);
		formData.append("content_desc", this.state.content_desc);
		formData.append("kelas_id",this.state.kelasNew)
		formData.append("content_tags", '');		
		formData.append("content_status", this.state.content_status);
		formData.append("jumlah_file", this.state.nama_files.length);
		// formData.append('nama_file', this.state.nama_file)
		
		var files=this.state.nama_files;
		// console.log(files[0])
		for (var i = 0; i < files.length; i++) {
			formData.append('file_' + i, files[i].nama_file);
		}

		const url = this.props.mode === "Tambah" ? "pengumuman/add" : "pengumuman/edit";

		this.setState({ isButtonLoading: true });

		axios
			.post(url, formData, config)
			.then(response => {
				const result = response.data;
				if (result.success) {
					Alert.success(result.message);
					this.props.history.replace("/pengumuman");
				} else {
					if (Array.isArray(result.message)) {
						result.message.map(item => {
							Alert.error(item);

							return true;
						});
					} else {
						Alert.error(result.message);
					}

					this.setState({ isButtonLoading: false });
				}
			})
			.catch(error => {
				console.log("ERROR", error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isButtonLoading: false });
			});
	}

	loadData() {
		if (this.props.mode === "Edit") {

			this.setState({ isLoading: true });

			axios({
				method: "get",
				url: "/pengumuman/" + this.props.match.params.content_id
			})
				.then(response => {
					const result = response.data;
					if (result.success) {
						const contentBlock = htmlToDraft(result.data.content_desc);
						
						if (contentBlock) {
							const contentState = ContentState.createFromBlockArray(
								contentBlock.contentBlocks
							);
							const editorState = EditorState.createWithContent(contentState);

							this.setState({
								editorState: editorState
							});
						}

						this.setState({
							cat_id: result.data.cat_id,
							content_id: result.data.content_id,
							content_type: result.data.content_type,
							content_name: result.data.content_name,
							content_image: result.data.content_image,
							content_shortdesc: result.data.content_shortdesc,
							kelas_id : result.data.kelas_id.split(","),
							content_desc: result.data.content_desc,
							content_status: result.data.content_status,
							nama_file_exist: result.data.file_content,
							previewImg:
								result.data.content_image !== ""
									? FOTO_CONTENT_HOST + result.data.content_image
									: null,
							defaultImg:
								result.data.content_image !== "" ? null : "./noimage.gif"
						});

						var data_kelas_id = []

						for (var i=0; i<this.state.kelas_id.length; i++) {
							var arr_kelas_id =[]
							arr_kelas_id["kelas_id"]= this.state.kelas_id[i]
							data_kelas_id[i] = arr_kelas_id
						}

						const participants = data_kelas_id.map(
							item => item.kelas_id
						);

						const kelasNew = data_kelas_id.map(item => ({
							"kelas_id": item.kelas_id
						}));
						//
						// newState.participants = participants.join(",");
						// newState.kelasNew = kelasNew

						this.setState(
							{
								kelasNew: participants.join(","),
								participants: participants.join(",")
							}
						);



					} else {
						Alert.error(result.message);
					}

					this.setState({ isLoading: false });
				})
				.catch(error => {
					console.log(error);
					Alert.error("Gagal terhubung ke server!");
					this.setState({ isLoading: false });
				});
		}
	}

	componentDidMount() {
		this.loadData();
		this.loadDataKelas();
	}

	render() {
		return (
			<div className="col-sm-12">
				<div className="card">
					<div className="card-header">{this.props.mode} Pengumuman</div>
					<div className="card-block">
						{this.state.isLoading ? (
							"Memuat Data..."
						) : (
							<div className="form-horizontal animated fadeIn">
								<div className="form-group row">
									<label className="col-md-2 form-control-label">Kelas</label>
									<div className="col-md-9">
										<Select
											multi
											value={this.state.participants}
											onChange={text =>
												this.handleChangeMultiSelect("participants", text)
											}
											options={this.state.dataKelas}
											placeholder="Kelas yang mengikuti"
											removeSelected={this.state.removeSelected}
										/>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-md-2 form-control-label">
										Judul Pengumuman
									</label>
									<div className="col-md-9">
										<input
											name="content_name"
											type="text"
											className="form-control"
											placeholder="Judul Pengumuman"
											onChange={this.handleChange}
											value={this.state.content_name}
										/>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-md-2 form-control-label">Gambar</label>
									<div className="col-md-5">
										<label
											className="btn btn-info"
											style={{ cursor: "pointer" }}
										>
											Choose Image ...
											<input
												ref="file"
												name="content_image"
												type="file"
												onChange={this.onChange.bind(this)}
												hidden
											/>
										</label>{" "}
										&nbsp;
										{/*this.state.previewImg && (
											<label
												onClick={this.clear.bind(this)}
												className="btn btn-danger"
												style={{ cursor: "pointer" }}
											>
												Clear
											</label>
										)*/}
										{this.state.defaultImg && (
											<div>
												<img
													src={this.state.defaultImg}
													className="img-thumbnail"
													style={{ width: "320px", height: "180px" }}
													alt=""
												/>
											</div>
										)}
										{this.state.previewImg && (
											<div>
												<img
													src={this.state.previewImg}
													className="img-thumbnail"
													style={{ width: "320px", height: "180px" }}
													alt=""
												/>
											</div>
										)}
										{this.state.image &&
										!this.state.previewImg && (
											<div>
												<Cropper
													ref="crop"
													image={this.state.image}
													width={320}
													height={180}
													onImageLoaded={this.imageLoaded.bind(this)}
												/>
												<button
													onClick={this.crop.bind(this)}
													className="btn btn-md btn-success"
												>
													Crop
												</button>
												&nbsp;
												<button
													onClick={this.clear.bind(this)}
													className="btn btn-md btn-danger"
												>
													Clear
												</button>
											</div>
										)}
									</div>
								</div>
								<div className="form-group row">
									<label className="col-md-2 form-control-label">
										Deskripsi Singkat
									</label>
									<div className="col-md-9">
										<textarea
											name="content_shortdesc"
											type="number"
											className="form-control"
											placeholder="Deskripsi Singkat"
											onChange={this.handleChange}
											value={this.state.content_shortdesc}
										/>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-md-2 form-control-label">
										Deskripsi Lengkap
									</label>
									<div className="col-md-9">
										<div>
											<Editor
												editorState={this.state.editorState}
												wrapperClassName="demo-wrapper"
												editorClassName="demo-editor"
												name="content_desc"
												onEditorStateChange={this.onEditorStateChange.bind(
													this
												)}
												toolbar={{
													options: [
														"inline",
														"blockType",
														"fontSize",
														"fontFamily",
														"list",
														"textAlign",
														"history",
														"link",
														"embedded",
														"emoji"
													]
												}}
											/>
										</div>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-md-2 form-control-label">
										Status Aktif
									</label>
									<div className="col-md-3">
										<FormDropdown
											items={status_aktif}
											onChange={this.handleChange}
											value={this.state.content_status}
											name="content_status"
										/>
									</div>
								</div>
								{
                                            this.props.mode === "Edit" && (

                                                <div className="form-group row">
                                                    <label className="col-md-2 form-control-label">File Terlampir</label>
                                                    <div className="col-md-10">
                                                        {/*{*/}
                                                        {/*    <span>                                                        */}
                                                        {/*        <a href={MEDIA_HOST + this.state.nama_file_exist} target="_blank" rel="noopener noreferrer">*/}
                                                        {/*            {this.state.nama_file_exist}*/}
                                                        {/*        </a>                                                        */}
                                                        {/*    </span>*/}
                                                        {/*}*/}
														{this.state.nama_file_exist.map(f => (
															<li key={f.content_file_nama}>

																<a href={MEDIA_HOST + f.content_file_nama} target="_blank" rel="noopener noreferrer">
																	{f.content_file_nama}
																</a>
																{/*<button*/}
																{/*	title="Hapus"*/}
																{/*	className="btn btn-sm btn-danger"*/}
																{/*	onClick={() => this.handleDeleteFile()}*/}
																{/*	type="button"*/}
																{/*>*/}
																{/*	<i className="fa fa-remove"></i>*/}
																{/*</button>*/}
															</li>
														))}
                                                    </div>
                                                </div>                                        
                                            )
                                        }
                                        <div className="form-group row">
                                            <label className="col-md-12 form-control-label">{this.props.mode === "Edit" && "Ganti"} File Lampiran</label>
                                            <div className="col-md-12">

                                                <Dropzone
                                                    onDrop={this.onDrop.bind(this)}
                                                    multiple
                                                    style={{
                                                        width: "100%",
                                                        height: "auto",
                                                        border: "2px dashed #e9e9e9",
                                                        padding: "20px 30px",
                                                        color: "#888",
                                                        cursor: "pointer",
                                                        textAlign: "center",
                                                        marginBottom: "15px"
                                                    }}
                                                >
                                                    Klik atau drop file disini untuk mengupload file
                                                </Dropzone>

												<ul>
													{this.state.nama_file.map(f => (
														<li key={f.name}>
															{f.name} - {f.size} bytes
															{/*<button*/}
															{/*	title="Hapus"*/}
															{/*	className="btn btn-sm btn-danger"*/}
															{/*	onClick={() => this.handleDeleteFile()}*/}
															{/*	type="button"*/}
															{/*>*/}
															{/*	<i className="fa fa-remove"></i>*/}
															{/*</button>*/}
														</li>
													))}
												</ul>
                                                {/*{*/}
                                                {/*    this.state.nama_file !== "" &&*/}
                                                {/*        <span>*/}
                                                {/*            {this.state.nama_file.name} {" "}*/}
                                                {/*            <button*/}
                                                {/*                title="Hapus"*/}
                                                {/*                className="btn btn-sm btn-danger"*/}
                                                {/*                onClick={() => this.handleDeleteFile()}*/}
                                                {/*                type="button"*/}
                                                {/*            >*/}
                                                {/*                <i className="fa fa-remove"></i>*/}
                                                {/*            </button>*/}
                                                {/*        </span>*/}


                                                {/*}*/}
												<br></br>
												<label>Note :</label><br></br>
												<label>File Upload Hanya bisa doc, docx, pdf, PDF, xls, xlsx</label><br></br>
												<label>Size file maksimal 2MB</label>
                                            </div>
                                        </div>
							</div>
						)}
					</div>
					<div className="card-footer">
						<button
							type="button"
							className="btn btn-md btn-primary"
							disabled={this.state.isButtonLoading && "disabled"}
							onClick={this.handleSubmit}
						>
							{this.state.isButtonLoading ? "Loading" : "Simpan"}
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default Forms;



// WEBPACK FOOTER //
// ./src/views/Pengumuman/Forms.js